import { Component, Input, inject } from '@angular/core';
import { EllipsisPipe } from 'src/app/shared/pipes/ellipsis.pipe';
import { CardContent } from 'src/app/types/card-content';

/**
 * basic riege card component to display content based on data
 * provided as an input object defined in type {@link CardContent}
 * the card template offers an `action-slot` to project any content
 * into the card actions container. To render that container it is required
 * to set an optional `action` flag.
 * @class CardComponent
 * @typedef {CardComponent}
 */
@Component( {
    selector: 'riege-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
} )
export class CardComponent {
    /** data to display in card */
    @Input( { required: true } ) data!: CardContent;
    @Input() classes?: string[];

    ellipsis = inject( EllipsisPipe );
}
